import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import id from "./rsc/strings/id.json"
import en from "./rsc/strings/en-US.json"

const resources = {
  en: {
    translation: en
  },
  id: {
    translation: id
  }
};

function detectLocale() {
  const saved = localStorage.getItem("locale");
  if (saved === "en" || saved === "id") return saved;
  const browserLang = navigator.language || "";
  if (browserLang.startsWith("id") || browserLang.startsWith("ms")) return "id";
  return "en";
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: detectLocale(),
    fallbackLng: "id",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;